// Widget: Image Teasers

import './index.scss';

export default class WidgetImageTeasers {
  constructor(root) {
    this.root = root;;

    this.list = this.root.querySelector('.list');
    this.teasers = this.root.querySelectorAll('.teaser');
    this.fixedImageBox = this.root.querySelector('.fixed-image-box');

    if (this.teasers.length > 1) {
      this.fixedImageImage = this.fixedImageBox.querySelector('.image');
      this.fixedImageImage.src = this.teasers[0].querySelector('.item__image').src;

      window.addEventListener('resize', this.handleResize.bind(this));
      window.addEventListener('scroll', this.handleScroll.bind(this));

      this.updateImagesPosition();
    } else {
      this.fixedImageBox.style.display = 'none';
      this.list.querySelectorAll('.item__image').forEach(item => {
        item.style.visibility = 'visible';
      });
    }
  }

  handleResize() {
    this.updateImagesPosition();
  }

  handleScroll() {
    this.updateImagesPosition();
  }

  updateImagesPosition() {
    if (window.innerWidth >= 1024) {
      let positionClass = this.getPositionClass();
      if (positionClass !== '' && !this.fixedImageBox.classList.contains(positionClass)) {
        switch (positionClass) {
          case 'fixed':
            this.fixedImageBox.classList.remove('at-bottom');
            break;
          case 'at-bottom':
            this.fixedImageBox.classList.remove('fixed');
            break;
        }

        this.fixedImageBox.classList.add(positionClass);
      } else if (positionClass == '') {
        this.fixedImageBox.classList.remove('fixed', 'at-bottom');
      }

      for (let i = 0; i < this.teasers.length; i++) {
        let teaserRect = this.teasers[i].getBoundingClientRect();
        let txtBlock = this.teasers[i].querySelector('.item__txt-block');
        let txtRect = txtBlock.getBoundingClientRect();
        if (teaserRect.top < window.innerHeight && // top of teaser is on screen
          (
            (txtRect.top < 0 && txtRect.height - Math.abs(txtRect.top) > 0) || // bottom of the text is on screen.
            (txtRect.top > 0 && txtRect.top < window.innerHeight) // top of the text is on screen.
          )
        ) {
          this.fixedImageImage.src = this.teasers[i].querySelector('.item__image').src;
          break;
        }
      }
    }
  }

  getPositionClass() {
    let listRect = this.list.getBoundingClientRect();
    if (listRect.top < 95 && listRect.height - Math.abs(listRect.top) > this.fixedImageBox.scrollHeight + 95) {
      return 'fixed';
    } else if (listRect.top < 95 && listRect.height - Math.abs(listRect.top) < this.fixedImageBox.scrollHeight + 95) {
      return 'at-bottom';
    } else {
      return '';
    }
  }
}
